import { render, staticRenderFns } from "./PermissoesUso.vue?vue&type=template&id=647c260e&scoped=true"
import script from "./PermissoesUso.vue?vue&type=script&lang=js"
export * from "./PermissoesUso.vue?vue&type=script&lang=js"
import style0 from "./PermissoesUso.vue?vue&type=style&index=0&id=647c260e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c260e",
  null
  
)

export default component.exports